/**
 * El movimiento que devuelve una herramienta porque alguien rechazó su
 * asignación (A-08).
 *
 * El back lo guarda como `reassignment` —si vuelve con su dueño anterior— o
 * como `return` —si vuelve al almacén—, así que en el historial se leía
 * «Reasignación» o «Devolución» y nada delataba que venía de un rechazo. Lo
 * que lo distingue es `rejectedMovementId`: el id del rechazo que lo provocó,
 * nulo en cualquier otro movimiento.
 */

/** La etiqueta propia. Nombra la fila, que es el retorno, no el rechazo en sí. */
export const RETORNO_POR_RECHAZO = 'Retorno por rechazo'

/**
 * La acción que se muestra, con la etiqueta propia cuando corresponde.
 *
 * Recibe la que saldría por el tipo de movimiento y la reemplaza solo si el
 * movimiento trae el rechazo que lo causó. Los movimientos anteriores a esta
 * columna la traen rellenada por la migración, así que también se leen bien.
 */
export function accionDelMovimiento<T extends string>(
  accionPorTipo: T,
  rejectedMovementId: string | null | undefined,
): T | typeof RETORNO_POR_RECHAZO {
  return rejectedMovementId ? RETORNO_POR_RECHAZO : accionPorTipo
}
